import { render, staticRenderFns } from "./FloatingLogoAnimation.vue?vue&type=template&id=f19a2bf0"
import script from "./FloatingLogoAnimation.vue?vue&type=script&lang=js"
export * from "./FloatingLogoAnimation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports